import { render, staticRenderFns } from "./pointApplyDetail.vue?vue&type=template&id=2a4c6f12&scoped=true&"
import script from "./pointApplyDetail.vue?vue&type=script&lang=js&"
export * from "./pointApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./pointApplyDetail.vue?vue&type=style&index=0&id=2a4c6f12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c6f12",
  null
  
)

export default component.exports